import { history } from 'umi';
import { fetchCurUser, fetchTheme } from '@/services/api';
import { getToken } from '@/utils/token';
import { setUser } from '@/utils/authority';
import { reloadAuthorized } from './utils/Authorized';
import { ConfigProvider, Modal } from 'antd';
import ReactDOM from 'react-dom';
import { Spin } from 'antd';
import React from 'react';
import { refreshAccessToken } from '@/utils/request';

const loginPath = '/user/login';

export async function getInitialState() {
  // 创建加载图标的容器
  const loadingContainer = document.createElement('div');
  loadingContainer.id = 'loading-icon';
  loadingContainer.style.position = 'fixed';
  loadingContainer.style.top = '100px';
  loadingContainer.style.left = '49%';
  loadingContainer.style.zIndex = '9999'; // 确保在最上层

  // 将容器添加到 body
  document.body.appendChild(loadingContainer);

  // 显示加载图标
  ReactDOM.render(<Spin size="large" />, loadingContainer);
  let theme = {};
  try {
    const themeResponse = await fetchTheme();
    theme = themeResponse;
    theme.config = JSON.parse(themeResponse.config) ?? {};
    window.theme = theme;
    ConfigProvider.config(window['theme'].config.ConfigProvider);
    console.log('ConfigProvider.config successful');
    if (theme.config?.htmlStyle) {
      const htmlDom = document.querySelector('html');
      Object.entries(theme.config.htmlStyle).forEach(([key, value]) => {
        htmlDom.style[key] = value;
      });
      console.log('Html.style successful');
    }
  } catch (e) {
    console.log('ConfigProvider.config failed', e);
  }
  const fetchUserInfo = async () => {
    try {
      const msg = await fetchCurUser();
      return msg;
    } catch (error) {
      // 不在这里跳转，让后续逻辑统一处理
      console.warn('Failed to fetch user info:', error);
      return undefined;
    }
  };

  // 确保内存中有可用的 access token，若无则通过刷新接口获取
  const ensureAccessToken = async () => {
    const tokenInState = getToken();
    if (tokenInState && tokenInState.access_token) {
      return tokenInState;
    }
    try {
      // refreshAccessToken 已经处理了 token 设置
      const refreshed = await refreshAccessToken();
      if (refreshed?.access_token) {
        return refreshed;
      }
    } catch (e) {
      // 刷新失败，保持未登录态
      console.warn('Failed to refresh token on page load:', e);
    }
    return null;
  };

  const isLoginPage = ['/user/login', '/user-authorize', '/oauth-authorize'].includes(
    window.location.pathname,
  );

  // 登录页不触发刷新 token，直接走默认态
  if (!isLoginPage) {
    // 如果有 token，尝试获取用户信息
    const token = await ensureAccessToken();

    if (token && token.access_token) {
      const currentUser = await fetchUserInfo();
      if (currentUser?.permissions) {
        setUser(currentUser);
        reloadAuthorized();
        // 移除加载图标
        ReactDOM.unmountComponentAtNode(loadingContainer);
        document.body.removeChild(loadingContainer);

        return {
          currentUser,
          theme,
        };
      }
      // 如果获取用户信息失败，可能是token无效，但不在这里跳转
      // 让 CheckPermissions 组件统一处理跳转逻辑
    } else {
      // 如果没有token，跳转到登录页
      history.replace(loginPath);
    }
  }

  // 移除加载图标
  ReactDOM.unmountComponentAtNode(loadingContainer);
  document.body.removeChild(loadingContainer);

  return {
    currentUser: { permissions: [] },
    theme,
  };
}

// 检查 in 域名可用性并弹窗提示
const IN_HOST_KEY = 'in_host_popup_hide_until';
const hideUntil = localStorage.getItem(IN_HOST_KEY);

if (!(hideUntil && Date.now() < Number(hideUntil)) && !location.hostname.startsWith('in')) {
  // 只在 https 或 http 下检测
  if (location.protocol === 'https:' || location.protocol === 'http:') {
    // 检查 in 域名是否可访问
    fetch(`https://in${location.host}`, { method: 'HEAD', mode: 'no-cors' })
      .then(res => {
        if (res.headers.get('ETag')) {
          // 弹窗提示
          Modal.confirm({
            title: '提示',
            content: <div>🚀 检测到可以使用内网域名加速访问，是否跳转？</div>,
            okText: <span>🚀 立刻前往</span>,
            cancelText: '7天内不再显示',
            onOk: () => {
              window.location.href = `https://in${location.host}`;
            },
            onCancel: () => {
              localStorage.setItem(IN_HOST_KEY, (Date.now() + 7 * 24 * 60 * 60 * 1000).toString());
            },
          });
        }
      })
      .catch(err => {
        console.log(err);

        // 不可访问则不处理
      });
  }
}
